// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  position: relative;
}

.icon-help {
  font-size: 1.8rem;
  color: var(--black);
}
.wrap-mount {
  position: absolute;
  top: 0;
  left: -0.3em;
  width: calc(100% + 0.6em);
  height: calc(100% + 2em);
}

.wrap {
  width: 32rem;
  filter: drop-shadow(0px 4px 10px rgba(97, 97, 97, 0.18));
  display: block;
  position: absolute;
  top: 2.8rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 16;
}
.wrap .popover-triangle {
  content: "";
  width: 2rem;
  height: 2rem;
  background: var(--white);
  position: absolute;
  top: 0;
  left: 50%;
  transform: rotate(45deg) translateX(-50%);
}
.wrap .popover {
  background: var(--white);
  padding: 2.65rem 1.6rem 2.65rem 2rem;
  border-radius: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
}
.wrap .popover .title-popover {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
}
.wrap .popover button {
  width: 160px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/shared/input-help/input-help.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;AACF;AAMA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;AAJF;;AAOA;EACE,YAAA;EACA,wDAAA;EAEA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AALF;AAOE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,yCAAA;AALJ;AAQE;EACE,wBAAA;EACA,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AANJ;AAQI;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AANN;AASI;EACE,YAAA;EACA,gBAAA;AAPN","sourcesContent":[":host {\n  display: inline-block;\n  position: relative;\n}\n\n.icon-help {\n  font-size: 1.8rem;\n  color: var(--black);\n\n  &:hover+.wrap {\n    // display: block;\n  }\n}\n\n.wrap-mount {\n  position: absolute;\n  top: 0;\n  left: -0.3em;\n  width: calc(100% + 0.6em);\n  height: calc(100% + 2em);\n}\n\n.wrap {\n  width: 32rem;\n  filter: drop-shadow(0px 4px 10px rgba(97, 97, 97, 0.18));\n  // display: none;\n  display: block;\n  position: absolute;\n  top: 2.8rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 16;\n\n  & .popover-triangle {\n    content: '';\n    width: 2rem;\n    height: 2rem;\n    background: var(--white);\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: rotate(45deg) translateX(-50%);\n  }\n\n  & .popover {\n    background: var(--white);\n    padding: 2.65rem 1.6rem 2.65rem 2rem;\n    border-radius: 0.8rem;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n\n    .title-popover {\n      font-family: Roboto;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 18px;\n      letter-spacing: 0em;\n      text-align: left;\n    }\n\n    button {\n      width: 160px;\n      margin-top: 10px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
